export default {
    namespaced: true,
    state: {
        dailyCheck: {},
        dailyChecks: [],
    },
    mutations: {
        setDailyChecks(state, pload) {
            state.dailyChecks = pload
        },
        setDailyCheck(state, pload) {
            state.dailyCheck = pload
        },
    },
    actions: {
        getDailyChecks({rootState, commit}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + `iseller/getdailycheck`
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        commit('setDailyChecks', response.data)
                        resolve(response)
                    }, error => {
                        reject(error)
                    })
            })
        }
    }
}